import { Outlet } from "react-router-dom";
import styles from '../style.module.scss'
import { Wrapper } from '../../../components/Layout';
import Menu from "../../../components/Menu";
import Header from "../../../components/Header";

export default function MainLayout() {

  return (
    <>
      <Wrapper menu={true}>
        <Menu menu={true} />
        <div className={styles.Content}>
          <Header controllerMenu={true} menu={true} />
          <div className={styles.pageContent}>
            <Outlet />
          </div>
        </div>
      </Wrapper>
    </>
  )
}
